import { render, staticRenderFns } from "./InsuffecientStock.vue?vue&type=template&id=981b7fa6&scoped=true&"
import script from "./InsuffecientStock.vue?vue&type=script&lang=js&"
export * from "./InsuffecientStock.vue?vue&type=script&lang=js&"
import style0 from "./InsuffecientStock.vue?vue&type=style&index=0&id=981b7fa6&scoped=true&lang=css&"
import style1 from "./InsuffecientStock.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981b7fa6",
  null
  
)

export default component.exports